export function tableWorker(HelperTable) {

    const selectorTable = '#table-worker';
    const elTable = $(selectorTable)

    if (!elTable.length) {
        return;
    }

    const canEditOther = ESR.Helper.canEditOther();
    const canViewReports = ESR.Helper.userCan('view_reports');

    const callbackTableColHeadWorkers = (data, type, row) => {
        let html = '';
        let counter = 0;

        row?.workers.forEach(worker => {
            const title = canEditOther ? `<span title="${worker.coef}">${worker.name}</span>` : worker.name;
            html += counter === 0 ? '' : ' <span>,</span> ';
            html += title;
            counter++;
        });

        return html;
    }


    let columns = [];


    columns = [
        {
            label: ESR.lang.id,
            data: 'id',
            className: 'id min-tablet-p',
            visible: true
        },
        {
             label: ESR.lang.project_title,
            data: 'post_title',
            className: 'post_title min-mobile',
            visible: true,
            orderable: true,
            render: function (data, type, row) {
                if (type === 'display') {
                    return row.post_title;
                } else if (type === 'filter') {
                    return row.post_id;
                }

                return data;
            }
        },
        {
             label: ESR.lang.service_title,
            data: 'service_title',
            className: 'service_title min-mobile',
            visible: true,
            orderable: false
        },
        {
            label: ESR.lang.date,
            data: 'date',
            name: 'date',
            className: 'date min-mobile',
            visible: true,
            orderable: true
        },
        {
            label: ESR.lang.qty,
            data: 'qty',
            className: 'qty min-tablet',
            visible: true,
            orderable: false
        },
        {
            label: ESR.lang.unit,
            data: 'unit',
            className: 'unit min-tablet',
            visible: true,
            orderable: false
        }
    ];

    if (canViewReports) {
        columns.push({
            label: ESR.lang.price,
            data: 'price',
            className: 'price min-tablet',
            visible: true,
            orderable: true
        })
        columns.push({
            label: ESR.lang.price_a_all,
            data: 'price_a',
            className: 'price_a',
            visible: false
        })
    }

    columns = [
        ...columns,
        {
            label: ESR.lang.workers,
            data: 'workers',
            className: 'workers',
            orderable: false,
            render: callbackTableColHeadWorkers,
            visible: false
        },
        {
            label: ESR.lang.created,
            data: 'created',
            className: 'created',
            visible: false
        },
        {
            label: ESR.lang.updated,
            data: 'updated',
            className: 'updated',
            visible: false
        },
        {
            label: ESR.lang.author,
            data: 'modified_name',
            className: 'moderator',
            visible: false,
            orderable: true
        }
    ];

    const myTableHeader = HelperTable.createRowHeader(columns);
    const myTableFooter = HelperTable.createRowFooterEmpty(columns)
    elTable.append(myTableHeader)
    elTable.append(myTableFooter)

    const table = new DataTable(selectorTable, {
        responsive: true,
        select: false,
        data: window.tableData,
        columns: columns,
        order: [
            [3, 'dsc']
        ],
        stateSave: true,
        processing: false,
        serverSide: false,
        info: false,
        layout: {
            // topStart: toolbar,
            topStart: {
                buttons: [
                    // 'pageLength',
                    {
                        extend: 'colvis',
                        className: 'btn btn-sm btn-neutral',
                    },
                    HelperTable.btnDownloads( document.querySelector('h1')?.textContent ?? '' ),
                ]
            },
            topEnd: {
                search: {
                    text: '',
                    placeholder: ESR.lang.search
                }
            },
        },
        language: {
            emptyTable: ESR.lang.emptyTable,
            buttons: {
                // colvis: 'Coloane',
            }
        },
        displayLength: 100,
        footerCallback: function (tfoot) {
            if (!canViewReports) return;

            let api = this.api();
            const elColHeader = api.columns('th').header();

            let indexColPrice;
            let indexColPriceAll;

            elColHeader.each(function (v, k) {
                const item = $(v);
                if (item.hasClass('price')) indexColPrice = k;
                if (item.hasClass('price_a')) indexColPriceAll = k;
            });

            if (indexColPrice) {
                const totalPrice = api.column(indexColPrice).data().reduce((a, b) => ESR.Helper.toFloat(a) + ESR.Helper.toFloat(b), 0);
                api.column(indexColPrice).footer().innerHTML = totalPrice.toFixed(2);
            }

            if (indexColPriceAll) {
                const totalPriceAll = api.column(indexColPriceAll).data().reduce((a, b) => ESR.Helper.toFloat(a) + ESR.Helper.toFloat(b), 0);
                api.column(indexColPriceAll).footer().innerHTML = totalPriceAll;
            }

        }
    });


}